import type { FrameContext } from '../playable';
import { TrackMixerPlayable } from './track-mixer-playable';

export class SpriteColorMixerPlayable extends TrackMixerPlayable {

  override evaluate (context: FrameContext): void {
  }
}
